// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2acdY","left":"InfoRow_left__1R8-H"};